import { render, staticRenderFns } from "./PackageA.vue?vue&type=template&id=543a9e33&"
import script from "./PackageA.vue?vue&type=script&lang=js&"
export * from "./PackageA.vue?vue&type=script&lang=js&"
import style0 from "./PackageA.vue?vue&type=style&index=0&id=543a9e33&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports